export const keyCodes = {
  ESCAPE: 27,
  ENTER: 13
};
